import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { CommonPostResponse } from '../../../components/models/models'

export class DeleteUserApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/user/delete',
      requesterInfo,
    })
  }

  public async deleteUser(id: number): Promise<CommonPostResponse> {
    this.props.url = `${this.props.url}?id=${id}`
    return await this.postAsync<CommonPostResponse>()
  }
}
